import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon, SmartphoneIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { MoreTestimonials } from './MoreTestimonials';
const plan = {
  name: '📘 THE 360° INJURY REHAB SYSTEM™',
  ideal: 'Anyone wishing to manage injury rehabilitation from scratch, without prior clinical experience',
  was: 'USD 38',
  now: '19',
  features: ['6 Complete Volumes (150+ pages)', 'Shoulder, Knee, Ankle, Spine, Hip & Elbow protocols', 'Real return-to-sport frameworks', '30-Day routine with visible progress', '5 Free Bonuses included', '7-Day Money-Back Guarantee'],
  cta: 'Get The 360° Injury Rehab System'
};
const trust = [{
  icon: LockIcon,
  label: '100% Secure Payment'
}, {
  icon: ZapIcon,
  label: 'Instant Access'
}, {
  icon: CreditCardIcon,
  label: 'Credit / Debit'
}, {
  icon: SmartphoneIcon,
  label: 'Android & iOS'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Pricing" className="bg-radial-glow w-full overflow-x-hidden" data-id="element-130" data-mp="3vzp55gxnu88h">
      <div className="mx-auto w-full max-w-5xl px-5 py-12" style={{
      paddingTop: "15px",
      paddingBottom: "15px"
    }} data-id="element-131" data-mp="4svvdoosx0sc">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto flex w-full max-w-md flex-col items-center rounded-3xl border border-grape/30 bg-white px-6 pb-7 pt-10 text-center shadow-[0_24px_60px_-28px_rgba(29,78,216,0.45)]" style={{
        paddingTop: "5px",
        paddingBottom: "5px"
      }} data-id="element-132" data-mp="9ta1h16ue0nq">
          <h3 className="font-display text-lg font-black text-plum" data-id="element-133" data-mp="3rzohr6sl2mpa">{plan.name}</h3>
          <p className="mt-2 text-sm text-plum/60" data-id="element-134" data-mp="2ui7ngb5c22tu">
            <span className="font-semibold text-plum/80" data-id="element-135" data-mp="2zgr9ebjxfem7">Ideal for:</span> {plan.ideal}
          </p>

          <div className="mt-6" data-id="element-136" data-mp="2rg35g6jtu4p1">
            <span className="text-base font-medium text-plum/40 line-through" style={{
            fontSize: "20px"
          }} data-id="element-137" data-mp="2rfa2zhrwi1cp">{plan.was}</span>
            <div className="flex w-full justify-center" style={{
            paddingTop: "9px",
            paddingBottom: "9px"
          }} data-id="element-138" data-mp="316ejilx85u9n">
              <span className="relative inline-block font-display leading-none" style={{
              fontFamily: "Montserrat, sans-serif"
            }} data-id="element-139" data-mp="2w83aueio1pt0">
                {/* Currency symbol — adjust fontSize here */}
                <span className="text-grape-shine absolute right-full top-1/2 -translate-y-1/2 font-black leading-none" style={{
                fontSize: "40px",
                marginRight: "4px",
                fontFamily: "Merriweather, serif"
              }} data-id="element-140" data-mp="23l0ffv9adv6z">
                  $
                </span>

                {/* Amount — stays centered on the page */}
                <span className="text-grape-shine font-black leading-none" style={{
                fontSize: "70px",
                fontFamily: "Merriweather, serif"
              }} data-id="element-141" data-mp="3ovgyfm0h590g">
                  {plan.now}
                </span>

                {/* Currency code — adjust fontSize here */}
                <span className="absolute left-full top-1/2 -translate-y-1/2 font-bold uppercase leading-none tracking-wide text-grape" style={{
                fontSize: "26px",
                marginLeft: "6px",
                fontWeight: "900",
                fontFamily: "Merriweather, serif"
              }} data-id="element-142" data-mp="3ngekpn7bos1t">
                  USD
                </span>
              </span>
            </div>
            <p className="mt-1 text-xs font-semibold text-grape" data-id="element-143" data-mp="a7s26s8wqmcd">
              One-time payment · Lifetime access
            </p>
            <p className="mt-1 text-[11px] font-medium text-plum/50" data-id="element-144" data-mp="e824nuxhqumh">
              Payment will be processed in your local currency.
            </p>
          </div>

          <ul className="mt-6 w-full flex-1 space-y-3 text-left" data-id="element-145" data-mp="16r964mmhopzh">
            {plan.features.map(f => <li key={f} className="flex items-start gap-2.5 text-sm text-plum/80" data-id="element-146" data-mp="3f8jug8yp4d46">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-147" data-mp="3a85y3o6girlz" />
                {f}
              </li>)}
          </ul>

          <div className="mt-7 flex w-full justify-center" data-id="element-148" data-mp="359m89coqsvoc">
            <CTAButton size="md" data-id="element-149" data-mp="318sngs6ljwzo">{plan.cta}</CTAButton>
          </div>

          <p className="mt-3 text-[11px] font-semibold text-plum/50" data-id="element-150" data-mp="1scircnv3m6i">
            You save $19 USD (50% OFF)
          </p>
          

          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-plum/55" data-id="element-151" data-mp="3szyiwvbdh6im">
            {trust.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-152" data-mp="3k5k5kyaek625">
                <Icon className="h-4 w-4 text-grape" data-id="element-153" data-mp="kjn83pdxvqwa" />
                {label}
              </span>)}
          </div>
        </motion.div>

        <MoreTestimonials data-id="element-154" data-mp="fqu2kzancej5" />

        <div className="mx-auto mt-12 flex w-full max-w-2xl items-start gap-3 rounded-2xl border border-grape/20 bg-white/80 p-5 text-left" data-id="element-155" data-mp="fqka9524pvaa">
          <ShieldCheckIcon className="mt-0.5 h-6 w-6 shrink-0 text-grape" data-id="element-156" data-mp="23dgb4odpuwia" />
          <p className="text-[15px] leading-relaxed text-plum/75" data-id="element-157" data-mp="27g35ox1ruvj6">
            <span className="font-display font-bold text-plum" data-id="element-158" data-mp="27hxr0cgygpns">
              🛡️ 7-Day Money-Back Guarantee.
            </span>{' '}
            If within the first 7 days you feel the ebook does not match what you need or does not
            give you the boost you were looking for, request your refund and we return 100% of your
            money. We want you to rehabilitate with peace of mind, risk-free.
          </p>
        </div>
      </div>
    </section>;
}